// Vendor Components
import {createContext} from 'react';

// eslint-disable-next-line import/prefer-default-export
export const SearchContext = createContext({
    refreshServicesData: undefined,
    resetForm: undefined,
    resetServiceData: undefined,
    resetSort: undefined,
    servicesDataKey: undefined,
    servicesDataSearch: undefined,
    servicesUnregisterStore: undefined,
    setQuery: undefined,
    setSort: undefined,
});
